import Quill from 'quill';
import ReactQuill from './components/ReactQuill';
import type { ReactQuillProps } from './types';
export default ReactQuill;
export type { ReactQuillProps };
export { Quill };